<tg-row>
    <tg-col class="summary-page-property-description-section__content">
        <span class="summary-page-property-description-section__content-label"
            >Property description:</span
        ><br />
        <div
            class="
                summary-page-property-description-section__content-description-container
            "
            [ngClass]="{
                'summary-page-property-description-section__content-description-container--max-height':
                    (showAll$ | async) === false
            }"
        >
            <span
                #descriptionElement
                class="
                    summary-page-property-description-section__content-value
                    summary-page-property-description-section__content-description
                "
                >{{ description }}</span
            >
            <div
                class="
                    summary-page-property-description-section__content-description-ellipsis
                "
                [ngClass]="{
                    'summary-page-property-description-section__content-description-ellipsis--visible':
                        (showAll$ | async) === false
                }"
            >
                ...
            </div>
        </div>
    </tg-col>
</tg-row>
<tg-row *ngIf="isMoreThanMaxLines$ | async">
    <tg-col class="summary-page-property-description-section__content">
        <button tgButton2 linkStyle (click)="onShowMore()">
            {{ (showAll$ | async) === false ? 'show more' : 'show less' }}
            <tg-icon-right
                size="small"
                name="basic-plus"
                alt="show more"
                *ngIf="(showAll$ | async) === false"
            >
            </tg-icon-right>
            <tg-icon-right
                size="small"
                name="basic-minus"
                alt="show less"
                *ngIf="showAll$ | async"
            >
            </tg-icon-right>
        </button>
        <br />
        <br />
    </tg-col>
</tg-row>
